import React, {useCallback, useContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {MessageKeys} from '../../core/constants/map.enums';
import {TRANSPORT_GROUPS} from '../../core/constants';
import {MapContext} from '../../services/map-v2/map.context';
import TransportComponent from './transport/transport';
import {DataContext} from '../../services/data-v2/data.context';

import './transports.scss';

function TransportsComponent({
    selected,
}: {
    selected?: any,
}) {

    const {t} = useTranslation();
    const {warningLocationVisibility} = useContext(MapContext);

    const [buttonsDisabled, setButtonsDisabled] = useState<Boolean>(true);
    const {realTimeWorker} = useContext(DataContext);

    useEffect(() => {
        setButtonsDisabled(warningLocationVisibility !== MessageKeys.NONE);
    }, [warningLocationVisibility]);

    const handleClick = useCallback(async () => {
        if (realTimeWorker) {
            try {
                await realTimeWorker.updateAllSharedServicesRealTimes();
            } catch (error) {
                console.error('Error al ejecutar updateAllSharedServicesRealTimes:', error);
            }
        }
    }, [realTimeWorker]);

    return <div className="transports">
        <div className="transports-box">
            {
                TRANSPORT_GROUPS.map((transport: any, index: number) =>
                    <div
                        key={index}
                        className="transports-container"
                        role="button"
                        tabIndex={0}
                        onClick={handleClick}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                handleClick();
                            }
                        }}
                    >
                        <TransportComponent
                            title={t(transport.title)}
                            id={transport.id}
                            icon={transport.icon}
                            selected={selected}
                            transportSlugs={transport.slugs}
                            disabled={buttonsDisabled}/>
                    </div>)
            }
        </div>
    </div>;
}

export default TransportsComponent;
